<div *ngIf="labelTranslation" class="__label-wrap">
  <span class="__label">{{ labelTranslation }}</span>
</div>

<div class="__value-wrap">
  <span class="__value">{{ value }} {{ unit }}</span>
</div>

<mat-slider
  class="__slider"
  [value]="value"
  thumbLabel
  [step]="step"
  [min]="minValue"
  [max]="sliderMaxValue"
  (input)="value = $event.value">
</mat-slider>

<div class="__range">
  <span>{{ minValue }} {{ unit }}</span>
  <span>max. {{ maxValue }} {{ unit }}</span>
</div>
